import { motion } from "framer-motion";
import { Leaf, ShieldCheck, Award, Clock, Users, Heart } from "lucide-react";

const reasons = [{icon:Leaf,title:"Du sol au plafond",desc:"Murs, plafonds, vitres et tapis : un entretien qui couvre vos besoins."},{icon:ShieldCheck,title:"R\u00e9sidentiel et commercial",desc:"Un m\u00eame point de contact pour votre maison et vos locaux."},{icon:Award,title:"Grand m\u00e9nage",desc:"Un nettoyage ponctuel pour rafra\u00eechir vos espaces."},{icon:Clock,title:"Entretien r\u00e9gulier",desc:"Discutez avec nous de la fr\u00e9quence adapt\u00e9e \u00e0 votre quotidien."},{icon:Users,title:"Selon vos besoins",desc:"D\u00e9m\u00e9nagement, travaux ou entretien courant : pr\u00e9cisez votre demande."},{icon:Heart,title:"Contact direct",desc:"Par téléphone ou par texto, parlons de votre projet."}];

const WhyChooseUs = () => {
  return (
    <section
      id="pourquoi"
      className="relative bg-[#101D2C] text-white py-24 md:py-32 overflow-hidden grain"
      data-testid="why-section"
    >
      <div className="absolute right-0 top-1/4 w-72 h-72 bg-[#58BCFA]/10 blur-3xl rounded-full pointer-events-none" />
      <div className="absolute left-10 bottom-20 w-24 h-24 stripes opacity-20" />

      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-14 md:mb-20 max-w-4xl"
        >
          <span className="divider-tag on-dark">Pourquoi Entretien Net Pro</span>
          <h2 className="mt-6 font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.02]">
            Le ménage, c'est un détail.
            <br />
            <span className="text-[#58BCFA]">La confiance, c'est tout.</span>
          </h2>
          <p className="mt-6 max-w-2xl text-base md:text-lg text-white/70 font-light leading-relaxed">
            Plus qu'un service de nettoyage : un partenaire qui prend soin de vos
            lieux comme s'ils étaient les nôtres.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10">
          {reasons.map((r, i) => {
            const Icon = r.icon;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
                className="group relative bg-[#101D2C] p-8 md:p-10 hover:bg-[#09121C] transition-colors duration-500"
                data-testid={`reason-${i}`}
              >
                <div className="text-[12px] uppercase tracking-[0.3em] text-white/30 mb-6">
                  0{i + 1}
                </div>
                <Icon className="h-9 w-9 text-[#58BCFA] mb-6 transition-transform duration-500 group-hover:scale-110 group-hover:rotate-3" />
                <h3 className="font-display font-bold text-xl md:text-2xl tracking-tight mb-3">
                  {r.title}
                </h3>
                <p className="text-sm text-white/65 leading-relaxed">{r.desc}</p>
                <div className="absolute bottom-0 left-0 h-[2px] w-0 bg-[#58BCFA] group-hover:w-full transition-all duration-700" />
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
